type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function ProfileIcon({ className, ...props }: Props) {
  return (
    <svg
      width="22px"
      height="23px"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        d="M7.63954 13.8476C7.79268 13.7635 7.88673 13.8424 8.00032 13.9018C9.80449 14.8467 11.6435 14.9261 13.5218 14.1396C13.5762 14.1198 13.6357 14.1046 13.6802 14.0651C14.0707 13.7336 14.4216 13.8675 14.8269 14.0901C16.7201 15.1341 18.6284 16.1583 20.5365 17.1775C21.3619 17.6178 21.7677 18.2805 21.7529 19.2154C21.743 19.7448 21.7529 20.2694 21.7529 20.7987C21.748 21.6745 21.1642 22.2533 20.2942 22.2533H1.73223C0.847575 22.2532 0.26939 21.699 0.254562 20.8184C0.244678 20.1901 0.240003 19.5666 0.264715 18.9383C0.294442 18.1963 0.655126 17.6277 1.29766 17.2764C3.40836 16.1237 5.52884 14.9954 7.63954 13.8476Z"
        fill="currentcolor"
      />
      <path
        d="M7.06146 2.59633C9.22657 0.117664 12.8155 0.132662 14.9609 2.62614C17.2397 5.27806 17.0965 9.46407 14.6299 11.8686C13.6215 12.8532 12.415 13.3827 10.848 13.4025C9.10811 13.3431 7.66461 12.482 6.60185 10.9533C4.86184 8.44487 5.06935 4.88213 7.06146 2.59633Z"
        fill="currentcolor"
      />
    </svg>
  );
}
